export const DEFAULT_ICONS_V2 = {
  link: `/icons/v2/link.svg`,
  "voice-memo": `/icons/v2/voice-memo.svg`,
  map: `/icons/v2/map.svg`,
  pdf: `/icons/v2/pdf.svg`,
  image: `/icons/v2/image.svg`,
  360: `/icons/v2/360.svg`,
  "3d": `/icons/v2/3d.svg`,
  vr: `/icons/v2/vr.svg`,
} as const;
